import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  DELETE_USER,
  RESET_ORG_USERS_PAGINATION_STATE,
  SET_EDIT_ORG_USER,
  SET_FILTER_ORG_USER,
  SET_ORG_USERS_SORTING_STATE
} from './actionTypes'

export const deleteUser = (userId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(`/organizations/:organizationId/users/${userId}`, DELETE_USER, { method: 'DELETE' }, { args: { userId } })
    )
  }
}

export const setFilter = (filter: unknown): AppThunk => {
  return dispatch => dispatch(createAction(SET_FILTER_ORG_USER, { filter }))
}

export const setSortingColumn = (sortBy?: string, sortOrder?: string): AppThunk => {
  return async dispatch => {
    if (sortBy && sortOrder) {
      dispatch(
        createAction(SET_ORG_USERS_SORTING_STATE, {
          sortingColumn: { [sortBy]: { direction: sortOrder.toLowerCase() } }
        })
      )
    } else {
      dispatch(createAction(SET_ORG_USERS_SORTING_STATE, { sortingColumn: {} }))
    }
  }
}

export const setEditUser = (isEditingUser: boolean): AppThunk => {
  return async dispatch => {
    dispatch(createAction(SET_EDIT_ORG_USER, { isEditingUser }))
  }
}

export const resetPaginationState = (): AppThunk => {
  return async dispatch => {
    dispatch(createAction(RESET_ORG_USERS_PAGINATION_STATE))
  }
}
